import { render, staticRenderFns } from "./BoardNoticeWebpart.vue?vue&type=template&id=99d41ffc"
import script from "./BoardNoticeWebpart.ts?vue&type=script&lang=ts&external"
export * from "./BoardNoticeWebpart.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports